import { useMemo } from "react";

import { AdminGridTable } from "../../../components/admin-console/admin-grid-table";
import { useRailways } from "../../../shared/hooks/use-railways";
import { MOCK_CONSTRUCTOR_ROADS } from "../../constructor-roads-page/constructor-roads-page.lib";
import { SERVICE_ROAD_COLUMNS, type ServiceApplyRoad } from "../service-detail-page.lib";

/** Вкладка «Применение на дорогах»: таблица дорог из базового справочника (как в заявке), фолбэк — мок. */
export const RoadsTabContent = () => {
  const { railways, isLoading } = useRailways();

  const roads = useMemo<ServiceApplyRoad[]>(
    () =>
      railways.length
        ? railways.map((railway) => ({ id: railway.value, name: railway.label, code: railway.value }))
        : MOCK_CONSTRUCTOR_ROADS.map((road) => ({ id: road.id, name: road.name, code: road.code })),
    [railways],
  );

  return (
    <AdminGridTable
      tableId="admin-service-roads-table"
      columns={SERVICE_ROAD_COLUMNS}
      rows={roads}
      isLoading={isLoading}
      className="h-[24rem] min-h-0"
    />
  );
};
